var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatchNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 135,
    viewBox: "0 0 152 135",
    width: 152,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76 134.991c37.106 0 67.186-30.217 67.186-67.491S113.106.01 76 .01C38.894.01 8.814 30.225 8.814 67.5c0 37.274 30.08 67.491 67.186 67.491z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74 117c30.376 0 55-24.624 55-55S104.376 7 74 7C43.625 7 19 31.624 19 62s24.625 55 55 55z",
    fill: "#4e678c",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.335 81.15l-32.13-.098.132-43.846 22.217.067 9.883 9.988z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.554 37.273l-.03 9.958 9.913.03z",
    fill: "#367cff",
    opacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.64 47.25a.212.212 0 00-.01-.054l-.008-.02a.198.198 0 00-.04-.06L32.7 37.128a.204.204 0 00-.133-.059l-.012-.002L10.338 37a.204.204 0 00-.205.206L10 81.052a.206.206 0 00.205.205l32.13.099a.205.205 0 00.204-.206l.102-33.889c.001-.003-.001-.007-.001-.012zm-9.883-9.48l4.563 4.61 4.624 4.674-9.214-.028zM10.409 80.847l.131-43.435 21.808.066-.029 9.752a.206.206 0 00.205.206l9.708.03-.1 33.477z",
    fill: "#262626"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.838 89.133l-43.815-.134.18-59.792 30.297.092 13.477 13.62z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 29.3l-.04 13.579 13.517.04z",
    fill: "#367cff",
    opacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.18 42.907a.21.21 0 00-.01-.052l-.008-.02a.202.202 0 00-.04-.061l-13.477-13.62a.207.207 0 00-.06-.042l-.018-.006a.2.2 0 00-.054-.011l-.012-.003L54.204 29a.204.204 0 00-.205.206l-.18 59.792a.206.206 0 00.204.205l43.815.134a.204.204 0 00.205-.206l.14-46.213c0-.002-.003-.006-.003-.01zm-13.477-13.11l12.78 12.916-12.819-.04zM54.228 88.793l.179-59.38 29.888.09-.041 13.374a.206.206 0 00.205.206l13.313.04-.138 45.802z",
    fill: "#262626"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.693 81.151l-32.13-.098.132-43.846 22.217.067 9.883 9.988z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.912 37.274l-.03 9.958 9.913.03z",
    fill: "#367cff",
    opacity: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M141.998 47.25a.193.193 0 00-.011-.053.204.204 0 00-.046-.08l-9.883-9.988a.217.217 0 00-.06-.041l-.019-.007a.204.204 0 00-.053-.01c-.005 0-.009-.003-.013-.003L109.695 37a.204.204 0 00-.204.206l-.132 43.846a.204.204 0 00.204.206l32.131.098a.207.207 0 00.205-.206l.102-33.889c-.001-.003-.003-.007-.003-.011zm-9.883-9.479l4.562 4.61 4.625 4.674-9.214-.029zm-22.347 43.077l.131-43.435 21.808.066-.029 9.752c0 .055.022.107.06.146.038.038.09.06.145.06l9.708.03-.101 33.477z",
    fill: "#262626"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.056 63.588a3.074 3.074 0 003.067-3.082c0-1.701-1.373-3.08-3.067-3.08s-3.067 1.379-3.067 3.08a3.074 3.074 0 003.067 3.082zM86.088 63.588a3.074 3.074 0 003.067-3.082c0-1.701-1.373-3.08-3.067-3.08s-3.067 1.379-3.067 3.08a3.074 3.074 0 003.067 3.082z",
    fill: "#292a2e"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M79.684 69.027H71.46a.204.204 0 01-.205-.205.206.206 0 01.205-.206h8.224a.204.204 0 01.205.206.206.206 0 01-.205.205z",
    fill: "#262626"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.892 69.32c1.511 0 2.736-.648 2.736-1.447s-1.225-1.446-2.736-1.446-2.736.647-2.736 1.446c0 .8 1.225 1.447 2.736 1.447zM89.252 69.32c1.511 0 2.736-.648 2.736-1.447s-1.225-1.446-2.736-1.446c-1.511 0-2.736.647-2.736 1.446 0 .8 1.225 1.447 2.736 1.447z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#367cff",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.892 69.32c1.511 0 2.736-.648 2.736-1.447s-1.225-1.446-2.736-1.446-2.736.647-2.736 1.446c0 .8 1.225 1.447 2.736 1.447zM89.252 69.32c1.511 0 2.736-.648 2.736-1.447s-1.225-1.446-2.736-1.446c-1.511 0-2.736.647-2.736 1.446 0 .8 1.225 1.447 2.736 1.447z",
    opacity: 0.4
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M98.043 42.946A29.936 29.936 0 0077.497 32.68a29.898 29.898 0 00-21.755 7.334c-10.019 8.765-13.098 23.337-7.486 35.44a30.018 30.018 0 004.296 6.73l.369.438-27.462 29.275a2.817 2.817 0 00.132 3.956 2.792 2.792 0 001.99.763 2.792 2.792 0 001.948-.867l27.455-29.271.458.344a29.887 29.887 0 0020.662 5.906 29.933 29.933 0 0019.29-9.494 30.195 30.195 0 008.02-20.019 30.207 30.207 0 00-7.37-20.269zm1.722 21.468a24.55 24.55 0 01-7.677 16.212 24.334 24.334 0 01-16.62 6.604c-.57 0-1.14-.02-1.715-.062a24.328 24.328 0 01-11.288-3.674 24.466 24.466 0 01-8.228-8.588 24.606 24.606 0 01-.68-23.114 24.484 24.484 0 017.71-9.06 24.34 24.34 0 0111.052-4.338A24.3 24.3 0 0184.1 39.806a24.403 24.403 0 019.727 6.827 24.392 24.392 0 014.74 8.293 24.467 24.467 0 011.197 9.488z",
    fill: "#005ce6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchNotFound);
export default __webpack_public_path__ + "static/media/match_not_found.5ebc9a6ae08a5888f8a756d7abb1ad49.svg";
export { ForwardRef as ReactComponent };